module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedt",
    attrs: {
      "id": "pageii"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For Squadron Leader Brian Lane DFC and all my departed personal friends who served on 19 Squadron 1938-1941.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("© Dilip Sarkar, 2018")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a0f472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedication.vue
// module id = 60
// module chunks = 0